import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { H6 } from 'components/typography/Headers';
import { CurrentUserDto } from 'services/user/userService.dto';
import { extractUserFacebookName } from 'utils/extractUserFacebookName';
import { formatMobilePhone } from 'utils/phoneFormatter';

import { AccountClosing } from './AccountClosing';
import { FacebookInput } from './FacebookInput';
import { UserDataInput } from './UserDataInput';

const Text = styled(H6)`
  margin-bottom: 24px;
`;

interface UserDataProps {
  currentUser: CurrentUserDto;
  refreshCurrentUser: () => void;
}

export const UserData = ({ currentUser, refreshCurrentUser }: UserDataProps) => {
  const { t } = useTranslation('myProfile');
  return (
    <div>
      <Text>{t('account-settings.user-data')}</Text>
      <UserDataInput label={t('account-settings.first-name')} value={currentUser.firstName} field={'firstName'} />
      <UserDataInput label={t('account-settings.last-name')} value={currentUser.lastName!} field={'lastName'} />
      <UserDataInput
        label={t('account-settings.phone')}
        value={currentUser.phone ? formatMobilePhone(currentUser.phone!) : ''}
        field={'phone'}
        onConfirmed={refreshCurrentUser}
      />
      <UserDataInput
        label={t('account-settings.email')}
        value={currentUser.email!}
        field={'email'}
        canEdit={currentUser.canEditEmail}
      />
      {currentUser.draftEmail && (
        <UserDataInput
          label={t('account-settings.new-email')}
          value={currentUser.draftEmail!}
          field={'new-email'}
          canEdit={currentUser.canEditEmail}
          confirmEmail={!!currentUser.draftEmail}
        />
      )}

      <FacebookInput
        label={t('account-settings.facebook')}
        value={extractUserFacebookName(currentUser)}
        refreshCurrentUser={refreshCurrentUser}
        facebookVerified={currentUser.facebookVerified}
      />
      <UserDataInput label={t('account-settings.about')} value={currentUser.about!} field={'about'} />
      <AccountClosing />
    </div>
  );
};
